import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
// import ButtonComp from '../button';
// import Typography from '@material-ui/core/Typography';
import { Button, Snackbar, Card, CardContent } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import LoaderPopUp from '../loaderpopup/loader';
import SuccessPopUp from '../loaderpopup/success';
import ErrorPopUp from '../loaderpopup/error';
import { CommonConfig } from '../../config/common-config';
import './styles.css';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        left: '0',
        bottom: '0',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    displayInline: {
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 0,
        '& li': {
            display: 'inline-block',
        },
    },
}));

export default function CheckListFooterIncorporation() {
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [updateStat, setUpdateStat] = useState(false);
    const [showLoaderSubmit, setShowLoaderSubmit] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const history = useHistory();
    const back = () => {
        history.push('/menu/openservice');
    };
    const generateChklist = () => {
        //console.log('chklist generated', serviceIdSelected);
        setShowLoaderSubmit(true);
        const chklistData = {
            serviceId: serviceIdSelected,
            remarks: 'Remarks',
            checklistJson: {},
        };

        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/checklist/creation/${tennantDetails}`, chklistData, {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log(response.status);
                if (response.status === 200) {
                    // console.log('GenerateL1', response);
                    setShowLoaderSubmit(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        history.push('/menu/openservice');
                    }, 3000);
                }
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                    setShowLoaderSubmit(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const classes = useStyles();
    const handleClose = () => {
        setShowLoaderSubmit(false);
    };

    return (
        <>
            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title="Checklist Generated Successfully"
                />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            {/* <Snackbar
                className="deleteError"
                open={updateStat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={3000}
                onClose={() => {
                    setUpdateStat(false);
                }}
            >
                <Alert
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    Checklist generated successfully.
                </Alert>
            </Snackbar> */}
            {/* {(showLoaderSubmit && (
                <div className={classes.centerAlign}>
                    <Button className={classes.submit} variant="outlined" width="55%" disabled>
                        <CircularProgress size={24} />
                    </Button>
                </div>
            )) || (
                <div>
                    <ul className={classes.displayInline}>
                        <li>
                            <Button variant="contained" color="primary" onClick={() => generateChklist()} className="btnBlue txt-cap">
                                Generate L1 CheckList for service No : {serviceIdSelected.toString()}
                            </Button>
                            <Button variant="contained" onClick={() => back()} className="btnBlue ml10 txt-cap" color="primary">
                                Cancel
                            </Button>
                        </li> */}
            {/* <li>
                    <ButtonComp className="checkListBtn" title="Cancel" />
                </li>
                <li>
                    <ButtonComp type="submit" className="checkListBtn" title="Save" />
                </li>
                <li>
                    <ButtonComp type="submit" className="checkListBtn" title="Next" />
                </li> */}
            {/* </ul>
                </div>
            )} */}

            <div>
                <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                    Back
                </Button>
                {/* <ul className={classes.displayInline}> */}
                {/* <li> */}
                {/* <div className="btnFloat">
                    {(showLoaderSubmit ? (
                        <LoaderPopUp
                            showLoader={showLoaderSubmit}
                            handleClose={handleClose}
                            title="Please wait while the checklist is being generated"
                        />
                    ) : null) || (
                        <Button
                            variant="contained"
                            color="primary"
                            // onSubmit={() => generateChklist()}
                            onClick={() => generateChklist()}
                            className="btnBlue txt-cap"
                        >
                            Generate L1 CheckList
                            {/* Generate L1 CheckList for service No : {serviceIdSelected.toString()} */}
                {/* </Button> */}
                {/* )} */}
                {/* <Button variant="contained" onClick={() => back()} className="btnBlue ml10 txt-cap" color="primary">
                            Cancel
                        </Button> */}
                {/* </li>
                </ul> */}
                {/* </div> */}
            </div>
        </>
    );
}
